import { generateInteractionProps } from "@/utils/generate-smart-toilets-interactions"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const handleVideoClick = (heading, videoTitle, videoId, videoSrc) => {
  const interactionData = generateInteractionProps(videoTitle, {
    eventName: `pxp:${videoTitle}:video play`,
    eventAction: `pxp:${videoTitle}:video play`,
    internalLinkName: "video play",
    internalLinkPosition: `pxp:${heading}:video teaser`,
    internalLinkType: `pxp:${videoTitle}`,
    internalLinkZoneName: "pxp:shop smart toilets:compare models",
    videoId,
    videoName: videoTitle,
    videoType: "autoplay",
    internalLinkURL: videoSrc,
    eventType: "teaser",
  })

  pushAnalyticsObjToDataLayer({ ...interactionData })
}
